import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useCallback, useRef } from "react";
import { MagicMomentFillIn } from "./magic-moment-fill-in";
import {
  buildMagicMomentMessage,
  getMagicMomentTokens,
} from "./magic-moment-tokens";

interface MagicMomentMessageEditorProps {
  teenGender: "male" | "female" | null;
  onInsertToChat?: (text: string) => void;
  className?: string;
  insertClassName?: string;
}

export function MagicMomentMessageEditor({
  teenGender,
  onInsertToChat,
  className,
  insertClassName,
}: MagicMomentMessageEditorProps) {
  const tokens = getMagicMomentTokens(teenGender);
  const valuesRef = useRef<Record<string, string>>({});

  const setValue = useCallback((id: string, value: string) => {
    valuesRef.current[id] = value;
  }, []);

  const handleInsert = () => {
    onInsertToChat?.(buildMagicMomentMessage(tokens, valuesRef.current));
  };

  return (
    <>
      <div
        className={cn(
          "select-text rounded-2xl bg-white p-4 font-body text-body-2 text-text-primary shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]",
          className,
        )}
      >
        <p>
          {tokens.map((token, index) => {
            if (typeof token === "string") {
              return <span key={`t-${index}`}>{token}</span>;
            }
            return (
              <MagicMomentFillIn
                key={`${teenGender}-${token.id}`}
                placeholder={token.placeholder}
                onChange={(value) => setValue(token.id, value)}
              />
            );
          })}
        </p>
      </div>
      {onInsertToChat ? (
        <Button
          variant="ghost"
          onClick={handleInsert}
          className={cn(
            "h-auto self-start p-0 font-body text-body-3 font-bold text-text-primary hover:bg-transparent hover:text-text-secondary",
            insertClassName,
          )}
        >
          Insert message
        </Button>
      ) : null}
    </>
  );
}
